<template>
  <div class="history-toggle">
    <v-btn
      variant="outlined"
      min-width="48"
      width="48"
      class="history-icon"
      :active="currentTab === 'history'"
      @click="setCurrentTab('history')"
    >
      <v-progress-circular
        v-if="isRevisionSaving || isRescoring"
        indeterminate
        color="brandPrimary"
        size="24"
        width="3"
        class="ml-1"
      />
      <DpplSvg
        v-else
        file-name="icons/icon-history"
      />
    </v-btn>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useDocumentRightPanel } from '@/stores/document/rightPanel';
import { useEditor } from '@/stores/editor/editor';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

const rightPanelStore = useDocumentRightPanel();
const { currentTab } = storeToRefs(rightPanelStore);
const { setCurrentTab } = rightPanelStore;
const { isRevisionSaving } = storeToRefs(useEditor());
const { isRescoring } = storeToRefs(useCurrentJobProfile());
</script>

<style lang="less" scoped>
.history-icon {
  border-color: @stroke-default;
  svg {
    color: @icon-default;
  }
}
</style>
